import { PageNotAvailableContent, PrimaryButton } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

type Props = {
  message?: string;
};

export const NotFoundPage = ({ message }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <PageNotAvailableContent>
      <p>{message ?? formatMessage("notFoundContent")}</p>
      <PrimaryButton href="/">{formatMessage("home")}</PrimaryButton>
    </PageNotAvailableContent>
  );
};

const formatStrings = {
  home: {
    en: "Dashboard",
  },
  notFoundContent: {
    en: "The page you are trying to visit cannot be found. Try returning to the home page.",
  },
  notFoundHeader: {
    en: "Not Found",
  },
} satisfies FormatMessages;
